import React from "react";
import { View, StyleSheet } from "react-native";
import { createStackNavigator } from "@react-navigation/stack";
import { useSafeAreaInsets } from "react-native-safe-area-context";
// import { useNavigationState } from "@react-navigation/native";

import HomeStackNavigator from "./HomeStackNavigator";
import InvestmentStackNavigator from "./InvestmentStackNavigator";
import PaymentStackNavigator from "./PaymentStackNavigator";
import TaxStackNavigator from "./TaxStackNavigator";
import AgreementStackNavigator from "./AgreementStackNavigator";
import EmulateUserStackNavigator from "./EmulateUserStackNavigator";
import PropertyStackNavigator from "./PropertyStackNavigator";
import ProfileStackNavigator from "./ProfileStackNavigator";
import CustomHeader, { HEADER_HEIGHT } from "../components/CustomHeader";
import RefreshWrapper from "../components/RefreshControl";
import BiometricStackNavigator from "./BiometricsStackNavigator";
import EMIStackNavigator from "./EMIStackNavigator";

const Stack = createStackNavigator();

const AppNavigator = () => {
  const insets = useSafeAreaInsets();
  const screens = [
    { name: "Home", Component: HomeStackNavigator },
    // { name: "BiometricAuthScreen", Component: BiometricStackNavigator },
    { name: "Investments", Component: InvestmentStackNavigator },
    { name: "EMI", Component: EMIStackNavigator },
    { name: "Payments", Component: PaymentStackNavigator },
    { name: "Tax", Component: TaxStackNavigator },
    { name: "Agreements", Component: AgreementStackNavigator },
    { name: "EmulateUser", Component: EmulateUserStackNavigator },
    { name: "Properties", Component: PropertyStackNavigator },
    { name: "Profile", Component: ProfileStackNavigator },
  ];

  // const currentRoute = useNavigationState((state) => {
  //   const routeName = state?.routes[state.index]?.name;
  //   if (!routeName) {
  //     return "BiometricAuthScreen";
  //   }

  //   return routeName;
  // });

  return (
    <View style={styles.container}>
      <CustomHeader />

      <View style={[styles.navigator, { marginTop: insets.top + HEADER_HEIGHT }]}>
        <Stack.Navigator
          initialRouteName="Investments"
          screenOptions={{
            headerShown: false, // Disable native headers
          }}
        >
          {screens.map(({ name, Component }) => (
            <Stack.Screen
              key={name}
              name={name}
              options={{ headerShown: false }}
            >
              {() => <Component />}
            </Stack.Screen>
          ))}
        </Stack.Navigator>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
  navigator: {
    // marginTop is applied inline: safe-area top inset + header height.
    flex: 1,
  },
});

export default AppNavigator;
